// import React from 'react';

// import { motion } from 'framer-motion';
// import { Check, Zap, Building2, Rocket, Globe, ChevronRight } from 'lucide-react';
// import { Link } from 'react-router-dom';
// import Footer from '../components/Footer';

// const PricingTier = ({ tier, index }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 30 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     viewport={{ once: false, amount: 0.2 }}
//     transition={{ delay: index * 0.1, duration: 0.6 }}
//     className={`relative group bg-[#0a0a0b]/80 backdrop-blur-xl border ${tier.featured ? 'border-blue-500/50' : 'border-white/10'} rounded-[2.5rem] p-6 md:p-10 flex flex-col shadow-2xl transition-all duration-500 hover:border-white/20 w-full max-w-[340px] md:max-w-none mx-auto`}
//   >
//     {tier.featured && (
//       <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-[10px] font-black px-5 py-2 rounded-full uppercase tracking-widest shadow-xl z-20">
//         Most Popular
//       </div>
//     )}

//     <div className="mb-6">
//       <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${tier.color} flex items-center justify-center mb-4 shadow-lg`}>
//         <tier.icon className="w-6 h-6 text-white" />
//       </div>
//       <h3 className="text-xl font-bold text-white mb-1">{tier.name}</h3>
//       <p className="text-xs text-gray-400 font-light line-clamp-2">{tier.description}</p>
//     </div>

//     <div className="mb-6">
//       <div className="flex items-baseline gap-1">
//         <span className="text-4xl md:text-5xl font-bold text-white tracking-tight">{tier.price}</span>
//         {tier.price !== 'Custom' && <span className="text-gray-500 text-lg">/mo</span>}
//       </div>
//     </div>

//     <ul className="space-y-3 mb-8">
//       {tier.features.map((feature, idx) => (
//         <li key={idx} className="flex items-start gap-3 group/item text-xs md:text-sm">
//           <div className="mt-1 w-4 h-4 rounded-full bg-blue-500/10 flex items-center justify-center shrink-0">
//             <Check className="w-3 h-3 text-blue-400" />
//           </div>
//           <span className="text-gray-300 font-light leading-snug">
//             {feature.includes('FREE') ? (
//               <>
//                 {feature.replace('FREE', '')}
//                 <span className="text-blue-400 font-bold ml-1">FREE</span>
//               </>
//             ) : feature}
//           </span>
//         </li>
//       ))}
//     </ul>

//     <Link 
//       to="/contact" 
//       className={`w-full py-4 rounded-full text-center font-bold text-sm md:text-base transition-all flex items-center justify-center gap-2 group/btn ${
//         tier.featured 
//         ? 'bg-[#0071e3] text-white hover:bg-[#0077ED] shadow-xl shadow-blue-500/20 hover:scale-[1.02]' 
//         : 'bg-white/5 text-white border border-white/10 hover:bg-white/10 hover:border-white/20'
//       }`}
//     >
//       {tier.name === 'Starter' ? 'Start Free' : 'Book Demo'}
//       <ChevronRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
//     </Link>
//   </motion.div>
// );

// const Price = () => {
//   const tiers = [
//     {
//       name: "Basic",
//       description: "Essential tools for small teams looking to connect their workflows.",
//       price: "FREE",
//       icon: Rocket,
//       color: "from-blue-500 to-cyan-500",
//       features: [
//         "Core HRM & Recruitment FREE",
//         "Job Post Management",
//         "Application Reports",
//         "Unified Dashboard Access",
//         "End To End Recruitment",
//         "Email Support"
//       ],
//       featured: false
//     },
//     {
//       name: "Premium",
//       description: "Advanced systems for growing businesses scaling their operations.",
//       price: "₹500",
//       icon: Zap,
//       color: "from-indigo-600 to-purple-600",
//       features: [
//         "Recruitment + Payroll Upto 50 Login",
//         "Attendance Management",
//         "Role‑based access for employees, managers, HR.",
//         "Manage employee records and onboarding.",
//         "Generate payslips and basic payroll reports.",
//         "Applicants & Employee Reports",
//         "Priority Email Support"
//       ],
//       featured: true
//     },
//     {
//       name: "Others",
//       description: "Custom architecture designed for multi-national corporations.",
//       price: "1000",
//       icon: Globe,
//       color: "from-slate-700 to-slate-900",
//       features: [
//         "Recruitment + Payroll Upto 100 Login",
//         "Attendance Management",
//         "Role‑based access for employees, managers, HR.",
//         "Manage employee records and onboarding.",
//         "Generate payslips and basic payroll reports.",
//         "Applicants & Employee Reports",
//         "Priority Email Support"
//       ],
//       featured: false
//     }
//   ];

//   return (
//     <main className="bg-black text-white h-screen overflow-y-auto snap-y snap-mandatory scroll-smooth font-sans no-scrollbar selection:bg-blue-500/30">

//       {/* Background Elements */}
//       <div className="fixed inset-0 z-0">
//         <div className="absolute top-[-10%] left-[-10%] w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[150px] animate-pulse"></div>
//         <div className="absolute bottom-[-10%] right-[-10%] w-[800px] h-[800px] bg-indigo-600/10 rounded-full blur-[180px]"></div>
//       </div>

//       {/* Hero Section */}
//       <section className="snap-start h-screen w-full flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="relative z-10"
//         >
//           <h1 className="text-5xl md:text-7xl lg:text-9xl font-bold tracking-tight mb-8">
//             Simple Pricing. <br />
//             <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-500">Universal System.</span>
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-400 font-light max-w-3xl mx-auto mb-12">
//             Choose the ecosystem that scales with your ambition. One login, one dashboard, complete control.
//           </p>
//           <motion.div
//             animate={{ y: [0, 10, 0] }}
//             transition={{ duration: 2, repeat: Infinity }}
//             className="flex flex-col items-center gap-2 opacity-50"
//           >
//             <span className="text-[10px] uppercase tracking-widest">Scroll to explore plans</span>
//             <div className="w-px h-12 bg-white/20"></div>
//           </motion.div>
//         </motion.div>
//       </section>

//       {/* Mobile Snap Sections (Individual Cards) / Desktop Single Section */}
//       {/* For desktop we show all 3, for mobile we can snap each one */}
//       <section className="hidden lg:flex snap-start h-screen w-full items-center justify-center px-6">
//         <div className="max-w-7xl mx-auto grid grid-cols-3 gap-8 w-full">
//           {tiers.map((tier, idx) => (
//             <PricingTier key={idx} tier={tier} index={idx} />
//           ))}
//         </div>
//       </section>

//       {/* Mobile Only: Individual Card Snaps */}
//       {tiers.map((tier, idx) => (
//         <section key={idx} className="lg:hidden snap-start h-screen w-full flex items-center justify-center px-6 py-10">
//           <PricingTier tier={tier} index={0} />
//         </section>
//       ))}

//       {/* FAQ & Footer Section */}
//       <section className="snap-start min-h-screen w-full flex flex-col pt-20">
//         <div className="flex-grow flex flex-col items-center justify-center px-6 max-w-4xl mx-auto text-center mb-20">
//            <h2 className="text-4xl md:text-5xl font-bold mb-16 tracking-tight">Flexible for every business</h2>
//            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
//               <div className="space-y-4">
//                  <h4 className="text-xl font-bold text-white flex items-center gap-3">
//                     <Building2 className="w-6 h-6 text-blue-500" /> Pay only for what you need
//                  </h4>
//                  <p className="text-gray-400 font-light leading-relaxed text-sm md:text-base">
//                     Scale your plan up or down as your team grows. Add modules individually or choose a comprehensive tier.
//                  </p>
//               </div>
//               <div className="space-y-4">
//                  <h4 className="text-xl font-bold text-white flex items-center gap-3">
//                     <Zap className="w-6 h-6 text-indigo-500" /> No hidden implementation fees
//                  </h4>
//                  <p className="text-gray-400 font-light leading-relaxed text-sm md:text-base">
//                     Our pricing is transparent. Get your system up and running without unexpected setup costs.
//                  </p>
//               </div>
//            </div>
//         </div>

//       </section>

//     </main>
//   );
// };

// export default Price;




import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Zap, Building2, Rocket, Globe, ChevronRight, Phone, MessageCircle, PhoneCall } from 'lucide-react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import BookingModal from '../components/BookingModal';

const PricingTier = ({ tier, index, onBook }) => (
  <div
    className={`relative group bg-[#0a0a0b]/80 backdrop-blur-xl border ${tier.featured ? 'border-blue-500/50' : 'border-white/10'} rounded-[1.8rem] md:rounded-[2rem] p-6 md:p-8 flex flex-col shadow-2xl transition-all duration-500 hover:border-white/20 w-full max-w-[320px] md:max-w-none mx-auto`}
  >
    {tier.featured && (
      <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-[10px] font-black px-5 py-2 rounded-full uppercase tracking-widest shadow-xl z-20">
        Most Popular
      </div>
    )}

    <div className="mb-6">
      <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${tier.color} flex items-center justify-center mb-4 shadow-lg`}>
        <tier.icon className="w-6 h-6 text-white" />
      </div>
      <h3 className="text-xl font-bold text-white mb-1">{tier.name}</h3>
      <p className="text-xs text-gray-400 font-light line-clamp-2">{tier.description}</p>
    </div>

    <div className="mb-6">
      <div className="flex items-baseline gap-1">
        <span className="text-3xl md:text-4xl font-bold text-white tracking-tight">{tier.price}</span>
        {tier.price !== 'FREE' && tier.price !== 'Custom' && (
          <span className="text-gray-500 text-base">/mo</span>
        )}
      </div>
      {tier.price === 'FREE' && (
        <span className="text-[10px] text-emerald-400 font-medium mt-1 block">No credit card required</span>
      )}
      {tier.price === 'Custom' && (
        <span className="text-[10px] text-orange-400 font-medium mt-1 block">Bespoke integrations</span>
      )}
    </div>

    <ul className="space-y-3 mb-8 flex-grow">
      {tier.features.map((feature, idx) => (
        <li key={idx} className="flex items-start gap-3 group/item text-xs md:text-sm">
          <div className="mt-1 w-4 h-4 rounded-full bg-blue-500/10 flex items-center justify-center shrink-0">
            <Check className="w-3 h-3 text-blue-400" />
          </div>
          <span className="text-gray-300 font-light leading-snug">
            {typeof feature === 'string' && feature.includes('FREE') ? (
              <>
                {feature.replace('FREE', '')}
                <span className="text-blue-400 font-bold ml-1">FREE</span>
              </>
            ) : feature}
          </span>
        </li>
      ))}
    </ul>

    {tier.isCustomContact ? (
      <div className="flex flex-col gap-3 mt-auto w-full">
        <a
          href="tel:+919010481048"
          className="w-full py-3.5 rounded-full text-center font-bold text-xs md:text-sm bg-white text-black hover:bg-gray-200 hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
        >
          <Phone className="w-4 h-4" />
          Call Sales Team
        </a>
        <a
          href="https://wa.me/919010481048?text=Hi%2C%20I%27m%20interested%20in%20a%20custom%20pricing%20plan%20for%20Ingrain%20Systems."
          target="_blank"
          rel="noopener noreferrer"
          className="w-full py-3.5 rounded-full text-center font-bold text-xs md:text-sm bg-[#25D366] text-white hover:bg-[#20ba5a] hover:scale-[1.02] transition-all flex items-center justify-center gap-2 shadow-lg shadow-[#25d366]/20"
        >
          <MessageCircle className="w-4 h-4 fill-white text-[#25D366]" />
          Chat on WhatsApp
        </a>
      </div>
    ) : (
      <button
        onClick={() => onBook(tier)}
        className={`w-full py-4 rounded-full text-center font-bold text-sm md:text-base transition-all flex items-center justify-center gap-2 group/btn mt-auto ${
          tier.featured
            ? 'bg-[#0071e3] text-white hover:bg-[#0077ED] shadow-xl shadow-blue-500/20 hover:scale-[1.02]'
            : 'bg-white/5 text-white border border-white/10 hover:bg-white/10 hover:border-white/20'
        }`}
      >
        {tier.name === 'Starter' ? 'Start Free' : 'Book Now'}
        <ChevronRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
      </button>
    )}
  </div>
);

const Price = () => {
  const [tiers, setTiers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleBook = (plan) => {
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://api.ingrainsystems.com/api/clients/allplans');
        const data = await response.json();
        
        const apiPlans = data?.plans || [];

        // ✅ FILTER: Skip plans where planFor is "timelyhealth"
        const filteredPlans = apiPlans.filter(plan => 
          plan.planFor?.toLowerCase() !== 'timelyhealth'
        );

        const formattedPlans = filteredPlans.map((plan, index) => ({
          id: plan._id || plan.id,
          name: plan.name || "Plan",
          description: plan.description || "",
          price: plan.price === 0 ? "FREE" : plan.price ? `₹${plan.price}` : "Custom",
          priceValue: plan.price || 0,
          icon: index === 0 ? Rocket : index === 1 ? Zap : Globe,
          color: index === 0 ? "from-blue-500 to-cyan-500" : index === 1 ? "from-indigo-600 to-purple-600" : "from-slate-700 to-slate-900",
          features: typeof plan.features === "string" ? plan.features.split(",") : plan.features || [],
          featured: index === 1,
          planFor: plan.planFor || 'client'
        }));

        // Sales Card - Always included
        const salesCard = {
          id: "custom-sales",
          name: "Custom",
          description: "Didn't find a plan that matches your exact criteria? We design custom modules for your enterprise.",
          price: "Custom",
          icon: PhoneCall,
          color: "from-rose-600 to-orange-600",
          features: [
            "Bespoke system modules design",
            "Custom backend workflow integrations",
            "Tailored storage & server architecture",
            "Didn't match criteria? Let's build together!"
          ],
          featured: false,
          isCustomContact: true
        };

        // If no plans after filtering, show fallback + sales card
        if (formattedPlans.length === 0) {
          const fallbackPlans = [
            {
              id: "basic",
              name: "Basic",
              description: "Essential tools for small teams looking to connect their workflows.",
              price: "FREE",
              icon: Rocket,
              color: "from-blue-500 to-cyan-500",
              features: [
                "Core HRM & Recruitment FREE",
                "Job Post Management",
                "Application Reports",
                "Unified Dashboard Access",
                "End To End Recruitment",
                "Email Support"
              ],
              featured: false,
              planFor: 'client'
            },
            {
              id: "premium",
              name: "Premium",
              description: "Advanced systems for growing businesses scaling their operations.",
              price: "₹500",
              icon: Zap,
              color: "from-indigo-600 to-purple-600",
              features: [
                "Recruitment + Payroll Upto 50 Login",
                "Attendance Management",
                "Role‑based access for employees, managers, HR.",
                "Manage employee records and onboarding.",
                "Generate payslips and basic payroll reports.",
                "Applicants & Employee Reports",
                "Priority Email Support"
              ],
              featured: true,
              planFor: 'client'
            },
            {
              id: "others",
              name: "Others",
              description: "Custom architecture designed for multi-national corporations.",
              price: "₹1000",
              icon: Globe,
              color: "from-slate-700 to-slate-900",
              features: [
                "Recruitment + Payroll Upto 100 Login",
                "Attendance Management",
                "Role‑based access for employees, managers, HR.",
                "Manage employee records and onboarding.",
                "Generate payslips and basic payroll reports.",
                "Applicants & Employee Reports",
                "Priority Email Support"
              ],
              featured: false,
              planFor: 'client'
            }
          ];
          setTiers([...fallbackPlans, salesCard]);
        } else {
          setTiers([...formattedPlans, salesCard]);
        }
      } catch (err) {
        console.error("API Error:", err);
        // Fallback plans (without timelyhealth)
        const fallbackPlans = [
          {
            id: "basic",
            name: "Basic",
            description: "Essential tools for small teams looking to connect their workflows.",
            price: "FREE",
            icon: Rocket,
            color: "from-blue-500 to-cyan-500",
            features: [
              "Core HRM & Recruitment FREE",
              "Job Post Management",
              "Application Reports",
              "Unified Dashboard Access",
              "End To End Recruitment",
              "Email Support"
            ],
            featured: false,
            planFor: 'client'
          },
          {
            id: "premium",
            name: "Premium",
            description: "Advanced systems for growing businesses scaling their operations.",
            price: "₹500",
            icon: Zap,
            color: "from-indigo-600 to-purple-600",
            features: [
              "Recruitment + Payroll Upto 50 Login",
              "Attendance Management",
              "Role‑based access for employees, managers, HR.",
              "Manage employee records and onboarding.",
              "Generate payslips and basic payroll reports.",
              "Applicants & Employee Reports",
              "Priority Email Support"
            ],
            featured: true,
            planFor: 'client'
          },
          {
            id: "others",
            name: "Others",
            description: "Custom architecture designed for multi-national corporations.",
            price: "₹1000",
            icon: Globe,
            color: "from-slate-700 to-slate-900",
            features: [
              "Recruitment + Payroll Upto 100 Login",
              "Attendance Management",
              "Role‑based access for employees, managers, HR.",
              "Manage employee records and onboarding.",
              "Generate payslips and basic payroll reports.",
              "Applicants & Employee Reports",
              "Priority Email Support"
            ],
            featured: false,
            planFor: 'client'
          }
        ];

        const salesCard = {
          id: "custom-sales",
          name: "Contact Sales",
          description: "Didn't find a plan that matches your exact criteria? We design custom modules for your enterprise.",
          price: "Custom",
          icon: PhoneCall,
          color: "from-rose-600 to-orange-600",
          features: [
            "Bespoke system modules design",
            "Custom backend workflow integrations",
            "Tailored storage & server architecture",
            "Didn't match criteria? Let's build together!"
          ],
          featured: false,
          isCustomContact: true
        };

        setTiers([...fallbackPlans, salesCard]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-black text-white font-sans pt-[52px] md:pt-[64px] selection:bg-blue-500/30 overflow-x-hidden">
      {/* Background */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[150px] animate-pulse"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[800px] h-[800px] bg-indigo-600/10 rounded-full blur-[180px]"></div>
      </div>

      {/* Hero Section */}
      <section className="w-full flex flex-col items-center justify-center px-6 text-center relative pt-16 md:pt-24 pb-8 md:pb-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="relative z-10"
        >
          <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold tracking-tight mb-8">
            Simple Pricing. <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-500">
              Universal System.
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-400 font-light max-w-3xl mx-auto mb-12">
            Choose the ecosystem that scales with your ambition.<br/>One login, one dashboard, complete control.
            <br />
            <br />
            <br />
          </p>
        </motion.div>
      </section>

      {/* Loading State */}
      {loading ? (
        <section className="w-full px-4 sm:px-6 py-12 relative z-10">
          <div className="max-w-7xl mx-auto flex justify-center items-center min-h-[400px]">
            <div className="flex flex-col items-center gap-4">
              <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-400">Loading plans...</p>
            </div>
          </div>
        </section>
      ) : (
        /* Pricing Cards Grid Section */
        <section className="w-full px-4 sm:px-6 py-12 relative z-10">
          <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 w-full">
            {tiers.map((tier, idx) => (
              <PricingTier key={idx} tier={tier} index={idx} onBook={handleBook} />
            ))}
          </div>
        </section>
      )}

      {/* Bottom Section */}
      <section className="w-full flex flex-col pt-20 pb-10">
        <div className="flex-grow flex flex-col items-center justify-center px-6 max-w-4xl mx-auto text-center mb-20">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-16 tracking-tight"
          >
            Flexible for every business
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="space-y-4"
            >
              <h4 className="text-xl font-bold text-white flex items-center gap-3">
                <Building2 className="w-6 h-6 text-blue-500" /> Pay only for what you need
              </h4>
              <p className="text-gray-400 font-light leading-relaxed text-sm md:text-base">
                Scale your plan up or down as your team grows.
              </p>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="space-y-4"
            >
              <h4 className="text-xl font-bold text-white flex items-center gap-3">
                <Zap className="w-6 h-6 text-indigo-500" /> No hidden implementation fees
              </h4>
              <p className="text-gray-400 font-light leading-relaxed text-sm md:text-base">
                Transparent pricing with no surprises.
              </p>
            </motion.div>
          </div>
        </div>

        <Footer />
      </section>

      {selectedPlan && (
        <BookingModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          selectedPlan={selectedPlan}
        />
      )}
    </main>
  );
};

export default Price;